import {createApi} from "@reduxjs/toolkit/query/react";
import {fetchBaseFPNetQuery} from "../../../utils/fetchBaseFPNetQuery";
import {AziendaRecord} from "@commons/mapping/AziendaRecord";
import {GiustificativoRecord} from "@commons/mapping/GiustificativoRecord";
import {addURI, transformResponse} from "@commons/utils/APIParams";
import {CentroDiCostoRecord} from "@commons/mapping/CentroDiCostoRecord";
import {FornitoreRecord} from "@commons/mapping/FornitoreRecord";
import {DefinizioneGruppoRecord} from "@commons/mapping/DefinizioneGruppoRecord";
import {config} from "@commons/config.instance";

interface FornitoreFilterSelection {
    targetDomain: boolean | null,
    idDominio: number,
}

interface DefGruppoFilterSelection {
    idAziendaMaster: number,
}

export const aziendaMappingApi = createApi({
    reducerPath: 'aziendaMappingApi',
    baseQuery: fetchBaseFPNetQuery({baseUrl: config.getBaseUrl('FPNet')}),
    endpoints: (builder) => ({

        //https://fpnet2.ericed.it/FPNet2021/azienda/1-1/mapping?auth_token=c4ea036ea171471e13d980ccec316499&nowId=1672147475585&idAziendaCdiC=1
        getAziendeTabelle: builder.query<AziendaRecord[], { idAziendaMaster: number, idAzienda: number }>({
            query: ({idAziendaMaster, idAzienda}) => {

                return `/azienda/${idAziendaMaster}-${idAzienda}/mapping`;
            },
            //transformResponse,
        }),
        getAziendeINPS: builder.query<AziendaRecord[], { idAziendaMaster: number, idAzienda: number }>({
            query: ({idAziendaMaster, idAzienda}) => {

                return `/azienda/${idAziendaMaster}-${idAzienda}/mapping/inps`;
            },
            //transformResponse,
        }),
        getAziendeINAIL: builder.query<AziendaRecord[], { idAziendaMaster: number, idAzienda: number }>({
            query: ({idAziendaMaster, idAzienda}) => {

                return `/azienda/${idAziendaMaster}-${idAzienda}/mapping/inail`;
            },
            //transformResponse,
        }),
        getAziendeBanche: builder.query<AziendaRecord[], { idAziendaMaster: number, idAzienda: number }>({
            query: ({idAziendaMaster, idAzienda}) => {

                return `/azienda/${idAziendaMaster}-${idAzienda}/mapping/banca`;
            },
            //transformResponse,
        }),

        // https://fpnet2.ericed.it/FPNet2021/azienda/1420/giustificativo?view=Minimal&tipo=orario&tipoOre=mancanti&auth_token=17b73d5e2e7276e72d442a52fb18b48c&nowId=1673876495115
        getAziendeGiust: builder.query<GiustificativoRecord[], { idAziendaMaster: number }>({
            query: ({idAziendaMaster}) => {
                return `/azienda/${idAziendaMaster}/giustificativo?view=Minimal&tipo=orario&tipoOre=mancanti`;
            },
            //transformResponse,
        }),

        getDefinizioniGruppi: builder.query<DefinizioneGruppoRecord[], { idAziendaMaster: number }>({
            query: ({idAziendaMaster}) => {
                let params: string[] = ['soloGruppi=false'];
                return `/azienda/${idAziendaMaster}/tabella/definizione?${params.length > 0 ? '&' + encodeURI(params.join("&")) : ''}`;
            },
            transformResponse: addURI
        }),

        // http://fpnet.local/FPNet2021/azienda/67/tabella/cdic?auth_token=e894a1f88034e42741264496a6d758f2&nowId=1674125444315&view=Gruppi
        getAziendeCdiC: builder.query<CentroDiCostoRecord[], { idAziendaMaster: number }>({
            query: ({idAziendaMaster}) => {
                return `/azienda/${idAziendaMaster}/tabella/cdic`;
            },
            transformResponse,
        }),

        getAziendeMansione: builder.query<CentroDiCostoRecord[], { idAzienda: number }>({
            query: ({idAzienda}) => {
                return `/azienda/${idAzienda}/tabella/mansione`;
            },
            transformResponse,
        }),

        getAziendeRuolo: builder.query<CentroDiCostoRecord[], { idAzienda: number }>({
            query: ({idAzienda}) => {
                return `/azienda/${idAzienda}/tabella/ruolo`;
            },
            transformResponse,
        }),

        getAziendeTipoContratto: builder.query<CentroDiCostoRecord[], { idAzienda: number }>({
            query: ({idAzienda}) => {
                return `/azienda/${idAzienda}/tabella/contratto`;
            },
            transformResponse,
        }),

        GetAziendeQualifica: builder.query<CentroDiCostoRecord[], { idAzienda: number }>({
            query: ({idAzienda}) => {
                return `/azienda/${idAzienda}/tabella/qualifica`;
            },
            transformResponse,
        }),

        // http://fpnet.local/FPNet2021/azienda/109/tabella/gruppo-1?auth_token=e894a1f88034e42741264496a6d758f2&nowId=1674127330880
        getAziendeGruppi: builder.query<CentroDiCostoRecord[], { idAziendaMaster: number, idGruppo: number }>({
            query: ({idAziendaMaster, idGruppo}) => {
                return `/azienda/${idAziendaMaster}/tabella/gruppo-${idGruppo}`;
            },
            //transformResponse,
        }),

        // http://fpnet.local/FPNet2021/domain/1/fornitore?auth_token=51ef6932e3a1aecc8f9c2a2947cf70f2&nowId=1676276664536&targetDomain=true
        getAziendeFornitori: builder.query<FornitoreRecord[], Partial<FornitoreFilterSelection>>({
            query: (filter) => {
                let params: string[] = ['targetDomain=true'];
                return `/domain/${filter.idDominio}/fornitore?${params.length > 0 ? '&' + encodeURI(params.join("&")) : ''}`;
            },
            transformResponse: addURI
        }),

        //http://fpnet.local/FPNet2021/domain/1002/tabella-costo/1/voce?auth_token=5163612a6b3f828700a4fa84957fc8fb&nowId=1674723815230
        getVociTicket: builder.query<any, { idDominio: number | undefined, idTabellaCosti: number }>({
            query: ({idDominio, idTabellaCosti}) => {
                return `/domain/${idDominio}/tabella-costo/${idTabellaCosti}/voce`;
            },
            //transformResponse,
        }),
    }),
})
export const {
    useGetAziendeTabelleQuery,
    useGetAziendeINPSQuery,
    useGetAziendeINAILQuery,
    useGetAziendeBancheQuery,
    useGetAziendeGiustQuery,
    useGetAziendeCdiCQuery,
    useGetAziendeMansioneQuery,
    useGetAziendeRuoloQuery,
    useGetAziendeQualificaQuery,
    useGetAziendeTipoContrattoQuery,
    useGetDefinizioniGruppiQuery,
    useGetAziendeGruppiQuery,
    useGetAziendeFornitoriQuery,
    useGetVociTicketQuery,
} = aziendaMappingApi;

